import { MainView } from "../../../views/find/user";

export default function Component(props) {
    return (
        <>
            <MainView />
        </>
    );
}